@if ((navigationService.redirecting())) {
    <div class="redirecting">
        {{ 'woa.message.entry.redirecting' | translate }}
    </div>
} @else {
    <div class="scroller" woa-responsive (scroll)="scrolling()" #scroller>
        <div class="page" woa-responsive [pillarboxedOnDesktop]="'desktop'"
             [ngClass]="{
                 'sidebar-fixed': sidebarPosition() === 'fixed'
             }"
             [woa-css-var]="{
                 '--scroller-scrollbar-width': scrollerScrollbarWidth(),
                 '--content-width': contentWidth()
             }">
            @if (configurationModel.app()?.headerPlacement === AppHeaderPlacement.FULL_WIDTH) {
                @if (configurationModel.app()?.navbarPlacement === AppNavbarPlacement.PAGE_HEADER) {
                    <div class="page-header-navbar placement-full-width" #fullWidthHeaderNavbar
                        [ngClass]="{
                            'page-scrolled': scrollerTop() > 0,
                            'with-header-image': hasHeaderImage(),
                            'with-blank-header-image': hasBlankHeaderImage(),
                            'with-no-header-image': hasNoHeaderImage()
                        }">
                        <div class="page-header-navbar-body">
                            <woa-icon-button class="page-header-navbar-body-menu"
                                             [type]="IconButtonType.MENU" [disabled]="!enableNavMenuIcon()"
                                             (onActivate)="navigationService.createPage('woa-nav-menu-page', undefined, {alignment: PageAlignment.LEFT})"></woa-icon-button>
                            @if (configurationModel.app()?.showDesktopHeaderLogo) {
                                <div class="page-header-navbar-body-logo"
                                     [ngClass]="{
                                         'page-scrolled': scrollerTop() > 0,
                                         'with-header-image': hasHeaderImage(),
                                         'with-no-header-image': hasNoHeaderImage()
                                     }">
                                    <woa-logo [type]="'horizontal'"></woa-logo>
                                </div>
                            }
                            <div class="page-header-navbar-body-controls">
                                <woa-icon-button [type]="IconButtonType.SEARCH"
                                                 (onActivate)="onSearchMenu.emit()"></woa-icon-button>
                                <woa-icon-button [type]="IconButtonType.REFRESH"
                                                 (onActivate)="onRefresh.emit()"></woa-icon-button>
                            </div>
                        </div>
                    </div>
                }
                @if (hasHeaderImage()) {
                    <div class="page-header-image placement-full-width" #fullWidthHeaderImage
                        [ngClass]="{
                            'with-navbar': headerImageHasNavbar(),
                            'with-title-logo': showHeaderImageTitleLogo()
                        }">
                        <div class="page-header-image-body"
                             [woa-background-image]="[{
                                 image: orderingContextModel.headerImage(),
                                 opacity: orderingContextModel.headerImageOpacity(),
                                 classes: 'theme-header-image-color-pair'
                             }, {
                                 classes: 'theme-standard-page-header-color-pair'
                             }]">
                            @if (showHeaderImageTitleLogo()) {
                                <div class="page-header-image-body-title-logo">
                                    <woa-logo [type]="'horizontal'"></woa-logo>
                                </div>
                            }
                            @if (configurationModel.app()?.showDesktopHeaderVerticalLogo) {
                                <woa-logo class="page-header-image-body-page-logo" [type]="'vertical'"></woa-logo>
                            }
                        </div>
                    </div>
                }
            }
            <div class="page-container" #container>
                <div class="page-container-content" #content>
                    @if (showContentHeaderTitlebar()) {
                        <div #contentHeaderTitlebar class="page-container-content-titlebar">
                            <woa-logo [type]="'horizontal'"></woa-logo>
                        </div>
                    }
                    @if (configurationModel.app()?.headerPlacement === AppHeaderPlacement.CONTENT) {
                        @if (configurationModel.app()?.navbarPlacement === AppNavbarPlacement.PAGE_HEADER) {
                            <div class="page-header-navbar placement-content" #contentHeaderNavbar
                                [ngClass]="{
                                    'page-scrolled': scrollerTop() > 0,
                                    'with-header-image': hasHeaderImage(),
                                    'with-blank-header-image': hasBlankHeaderImage(),
                                    'with-no-header-image': hasNoHeaderImage()
                                }">
                                <div class="page-header-navbar-body">
                                    @if (configurationModel.isConsumerActor()) {
                                        <woa-icon-button class="page-header-navbar-body-menu"
                                                         [type]="IconButtonType.MENU" [disabled]="!enableNavMenuIcon()"
                                                         (onActivate)="navigationService.createPage('woa-nav-menu-page', undefined, {alignment: PageAlignment.LEFT})"></woa-icon-button>
                                    }
                                    @if (configurationModel.app()?.showDesktopHeaderLogo) {
                                        <div class="page-header-navbar-body-logo"
                                             [ngClass]="{
                                                 'page-scrolled': scrollerTop() > 0,
                                                 'with-header-image': hasHeaderImage(),
                                                 'with-no-header-image': hasNoHeaderImage()
                                             }">
                                            <woa-logo [type]="'horizontal'"></woa-logo>
                                        </div>
                                    }
                                    <div class="page-header-navbar-body-controls">
                                        <woa-icon-button [type]="IconButtonType.SEARCH"
                                                         (onActivate)="onSearchMenu.emit()"></woa-icon-button>
                                        <woa-icon-button [type]="IconButtonType.REFRESH"
                                                         (onActivate)="onRefresh.emit()"></woa-icon-button>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (configurationModel.app()?.showDesktopHeaderImage) {
                            <div class="page-header-image placement-content" #contentHeaderImage
                                [ngClass]="{
                                    'with-navbar': headerImageHasNavbar(),
                                    'with-title-logo': showHeaderImageTitleLogo()
                                }">
                                <div class="page-header-image-body"
                                     [woa-background-image]="[{
                                         image: orderingContextModel.headerImage(),
                                         opacity: orderingContextModel.headerImageOpacity(),
                                         classes: 'theme-header-image-color-pair'
                                     }, {
                                         classes: 'theme-standard-page-header-color-pair'
                                     }]">
                                    @if (showHeaderImageTitleLogo()) {
                                        <div class="page-header-image-body-title-logo">
                                            <woa-logo [type]="'horizontal'"></woa-logo>
                                        </div>
                                    }
                                    @if (configurationModel.app()?.showDesktopHeaderVerticalLogo) {
                                        <woa-logo class="page-header-image-body-page-logo" [type]="'vertical'"></woa-logo>
                                    }
                                </div>
                            </div>
                        }
                    }
                    @if (contentMessages()?.length) {
                        <div class="page-container-content-messages">
                            <ng-content select="woa-content-message"></ng-content>
                        </div>
                    }
                    <div class="page-container-content-header">
                        <ng-content select="[slot=content-header]"></ng-content>
                    </div>
                    <div class="page-container-content-body" #contentBody>
                        <div class="page-container-content-body-selector" #contentBodySelector
                             [style.top]="contentStickyTop()(contentBodySelector)">
                            <ng-content select="[slot=content-selector]"></ng-content>
                        </div>
                        <div class="page-container-content-body-details">
                            <div class="page-container-content-body-details-header" #contentBodyDetailsHeader
                                 [style.top]="contentStickyTop()(contentBodyDetailsHeader)">
                                <ng-content select="[slot=content-details-header]"></ng-content>
                            </div>
                            <div class="page-container-content-body-details-main" #contentBodyDetailsMain
                                 [style.top]="contentStickyTop()(contentBodyDetailsMain)">
                                <ng-content select="[slot=content-details-main]"></ng-content>
                            </div>
                        </div>
                    </div>
                    <div class="page-container-content-footer" #contentFooter>
                        @if (configurationModel.app()?.dietaryStatement && configurationModel.isConsumerActor()) {
                            <div class="page-container-content-footer-statement">
                                {{ configurationModel.app()?.dietaryStatement }}
                            </div>
                        }
                        <woa-legal-panel class="page-container-content-footer-links" [messageSet]="'nav-menu'"
                                         [showFeedback]="configurationModel.app()?.feedbackCategories.length > 0"></woa-legal-panel>
                    </div>
                </div>
                <div class="page-container-sidebar-placeholder" #sidebarPlaceholder>
                </div>
                <div class="page-container-sidebar" [ngClass]="{'with-navbar': showSidebarNavbar()}" #sidebar
                     (wheel)="scrollByWheel($event)"
                     (touchstart)="scrollByTouchStart($event)"
                     (touchmove)="scrollByTouchMove($event)">
                    @if (showSidebarNavbar()) {
                        <div class="page-container-sidebar-navbar"
                             [ngClass]="{
                                 'with-full-width-header': configurationModel.app()?.headerPlacement === AppHeaderPlacement.FULL_WIDTH && configurationModel.app()?.showDesktopHeaderImage
                             }">
                            @if (configurationModel.isConsumerActor()) {
                                <woa-icon-button class="page-container-sidebar-navbar-menu"
                                                 [type]="IconButtonType.MENU" [disabled]="!enableNavMenuIcon()"
                                                 (onActivate)="navigationService.createPage('woa-nav-menu-page', undefined, {alignment: PageAlignment.RIGHT})"></woa-icon-button>
                            }
                            <div class="page-container-sidebar-navbar-controls">
                                <woa-icon-button [type]="IconButtonType.SEARCH"
                                                 (onActivate)="onSearchMenu.emit()"></woa-icon-button>
                                <woa-icon-button [type]="IconButtonType.REFRESH"
                                                 (onActivate)="onRefresh.emit()"></woa-icon-button>
                            </div>
                        </div>
                    }
                    <div class="page-container-sidebar-content">
                        <div class="page-container-sidebar-content-header">
                            <ng-content select="[slot=sidebar-header]"></ng-content>
                        </div>
                        <div class="page-container-sidebar-content-body">
                            <ng-content select="[slot=sidebar-body]"></ng-content>
                            <woa-footer-messages>
                                <ng-content select="woa-footer-message, [slot=footer-messages]"
                                            slot="messages"></ng-content>
                            </woa-footer-messages>
                        </div>
                        <div class="page-container-sidebar-content-footer">
                            <ng-content select="[slot=sidebar-footer-start]"></ng-content>
                            <ng-content select="[woa-page-footer-control]"></ng-content>
                            <ng-content select="[slot=sidebar-footer-end]"></ng-content>
                            <div class="page-container-sidebar-content-footer-logo">
                                <woa-chewzie-attribution></woa-chewzie-attribution>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
